import React from 'react';
import Breadcrumb from '../../../components/layout/Breadcrumb';
import { useNavigate } from 'react-router-dom';

export default function Pendingrequest() {
    const navigate = useNavigate();

    const pendingrequestlist = [
        {
            id: 1, heading: 'Assets (2)', icon: require("assets/img/assets-list-icon.png"),
            asset: [
                { name: "Amit Raj", assetname: "Laptop" },
                { name: "Sonam Kumari", assetname: "Headphones" }
            ]
        },
        {
            id: 2, heading: 'Documents (2)', icon: require("assets/img/docs-list-icon.png"),
            docscontent: [
                { name: "Amit Raj", doc: "Final Year Marksheet" },
                { name: "Sonam Kumari", doc: "Intermediate Passing Certificate" }
            ]
        },
        {
            id: 3, heading: 'Leaves (3)', icon: require("assets/img/leaveslist-icon.png"),
            details: [
                { name: "Amit Raj", date: "20-02-2025" },
                { name: "Sonam Kumari", date: "22-02-2025" }
            ]
        },
        { id: 4, heading: 'Resignations (2)', icon: require("assets/img/resignation-list-icon.png") }
    ];
    const breadcrumbTrail = [
        { name: 'admin', path: '/admin/dashboard' },
        { name: 'offboarded', path: '/admin/offboarded' }
    ];
    const redirectUrls = {
        1: { path: '/admin/pendingrequest/asset-request-list' },
        2: { path: '/admin/PendingRequest/document-request-list' },
        3: { path: '/admin/PendingRequest/leave-request-list' },
        4: {
            path: '/admin/offboarded', state: {
                breadcrumbTrail,
            }
        }
    };

    return (
        <div className='container-fluid'>
            <div className=" d-flex justify-content-between align-items-center" style={{ flexDirection: "row-reverse", marginBottom: '-15px' }}>
                <div className="icons-list">
                    <Breadcrumb />
                </div>
            </div>
            <div style={{ textAlign: 'center', marginTop: '30px' }}>
                <h5 style={{ fontWeight: 'bold' }}>All Requests</h5>
            </div>
            <div className='pendingrequest-upper-container'>
                <div className="pendingrequest-container">
                    {pendingrequestlist.map((list) => (
                        <div className="col-md-12 mb-3" key={list.id}>
                            <div>
                                <div className="pending-request-card">
                                    <div className="header-container cursor-pointer">
                                        <button type="button" className="btn-interactive" onClick={() => navigate(redirectUrls[list.id].path, { state: redirectUrls[list.id].state })}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexDirection: 'column' }}>
                                                <img src={list.icon} alt="icon" style={{ width: '50px', height: '50px' }} />
                                                <div className='clearance-btn'>
                                                    <button type="button" className="btn-interactive" onClick={(e) => {
                                                        e.stopPropagation();
                                                        navigate(redirectUrls[list.id].path, { state: redirectUrls[list.id].state });
                                                    }}>
                                                        <img
                                                            src={require("assets/img/close-dropdown-icon.png")}
                                                            alt="toggle-icon"
                                                            className="icon-redirect" />
                                                    </button>
                                                </div>
                                                <p><b>{list.heading}</b></p>
                                            </div>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
